import { HIDE_SITE_LOADER, SHOW_SITE_LOADER } from "./type";

export const showSiteLoader = () => async (dispatch) => {
    dispatch({ type: SHOW_SITE_LOADER });
};

export const hideSiteLoader = () => async (dispatch) => {
    dispatch({ type: HIDE_SITE_LOADER });
};
